<div class="container" [class.hole]="platformType === HTVPlatform.PHILIPS">
  <app-header class="header" [title]="'PAGES.CHANNEL_GRID.TITLE' | translate"></app-header>
  <div class="channel-grid-content">
    <div class="channel-grid">
      <div class="channel-grid-inner">
        <ng-container *ngFor="let channel of channels; let $index = index">
          <div
            class="channel-card htv-selectable htv-autofocus {{ $index === 0 ? 'htv-focus' : '' }}"
            (focusin)="focusChannel(channel)"
            (click)="openChannelPage()"
            tabindex="-1">
            <div class="channel-card-inner">
              <ng-container *ngIf="channel.logoUrl">
                <img class="channel-card-logo" [src]="channel.logoUrl" />
              </ng-container>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
    <div class="channel-data">
      <div #channelPlayer class="channel-preview">
        <app-channel-player class="channel-preview__player"></app-channel-player>
        <div class="channel-preview__overlay" *ngIf="selectedChannel">
          <app-channel-progress class="channel-preview__progress" [channel]="selectedChannel"></app-channel-progress>
        </div>
      </div>
      <div class="channel-details">
        <ng-container *ngIf="selectedChannel">
          <div class="channel-details__current-program">
            <div class="channel-details__current-program__header">
              <div class="channel-details__current-program__title">
                <div class="mat-title-medium text-ellipsis">{{ selectedChannel.id }} - {{ selectedChannel.name }}</div>
                <div class="mat-title-medium text-ellipsis">
                  {{ (selectedChannel.liveEPG$ | async)?.currentProgram?.title | titlecase }}
                </div>
              </div>
            </div>
            <div class="channel-details__current-program__summary mat-body-medium">
              {{ (selectedChannel.liveEPG$ | async)?.currentProgram?.description }}
            </div>
          </div>
          <ng-container *ngIf="(selectedChannel.liveEPG$ | async)?.nextProgram">
            <div class="channel-details__next-program">
              <div class="mat-title-medium text-ellipsis">
                {{ 'PAGES.CHANNEL.NEXT_PROGRAM' | translate }}
              </div>
              <div class="mat-title-small text-ellipsis">
                {{ (selectedChannel.liveEPG$ | async)?.nextProgram?.start | momentp }}
                {{ (selectedChannel.liveEPG$ | async)?.nextProgram?.title | titlecase }}
              </div>
            </div>
          </ng-container>
        </ng-container>
      </div>
    </div>
  </div>
</div>
